import { Breadcrumb, Spin, Tree } from 'antd';
import type { DataNode } from 'antd/es/tree';
import { NavLink, useParams, useNavigate } from 'react-router-dom';
import { useEffect, useState } from 'react';
import { FolderOpenOutlined } from '@ant-design/icons';
import { useArticlesGet } from '../../../hooks/api/article';
import { IconFileText, IconFolder, IconFolderOpen } from '../../Common/Icon';

import styles from './index.module.scss';

export default function SubCategoryDetails(): React.ReactNode | null {
  const {
    name, id, catName, catId, subName, subId,
  } = useParams();
  const navigate = useNavigate();
  const articlesGet = useArticlesGet({ autoStart: false });

  useEffect(() => {
    if (subId) {
      articlesGet.fetch({
        pageSize: '100', subCategoryId: [subId], status: 'published', productId: id,
      });
    }
  }, [id]);

  const articles = articlesGet.data?.data ?? [];

  return (
    <div className="wrapper">
      <div className="breadcrumb">
        <Breadcrumb
          items={[
            { title: <NavLink to="/" className="breadcrumbLink">Help portal</NavLink> },
            {
              title: (
                <NavLink
                  to={`/product/${id}/${encodeURIComponent(name || '')}`}
                  className="breadcrumbLink"
                >
                  {name}
                </NavLink>
              ),
            },
            {
              title: (
                <NavLink
                  // eslint-disable-next-line max-len
                  to={`/category/${encodeURIComponent(name || '')}/${encodeURIComponent(id || '')}/${encodeURIComponent(catName || '')}/${encodeURIComponent(catId || '')}`}
                  className="breadcrumbLink"
                >
                  {catName}
                </NavLink>
              ),
            },
            { title: `${subName}` },
          ]}
        />
      </div>
      <h2 className={styles.title}>{subName}</h2>
      <div className={styles.subCategoryItems}>
        {articles
          ? articles.map((item) => (
            <div
              role="button"
              tabIndex={-1}
              className={styles.item}
              key={item.id}
              onClick={() => navigate(
                `/article/${name}/${id}/${item.id}`,
                {
                  state: {
                    subName, subId, catName, catId,
                  },
                },
              )}
            >
              <div className={styles.icon}>
                <IconFileText color="currentColor" />
              </div>
              {item.title}
            </div>
          ))
          : null}
      </div>
      {articlesGet.loading ? (
        <div className="spin">
          <Spin />
        </div>
      ) : null}
    </div>
  );
}
